import React, { Component, Fragment } from "react";
import classes from "./Modal.module.css";
import Backdrop from "../Backdrop/Backdrop";
interface IParentProps {
  childComp?: React.ReactNode;
  show: boolean;
  style: {};
}
type Props = IParentProps;
class Modal extends Component<Props> {
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.show !== this.props.show ||
      nextProps.children !== this.props.children
    );
  }
  render() {
    const { show, childComp, style } = { ...this.props };
    return (
      <Fragment>
        <Backdrop show={show}></Backdrop>
        <div
          className={classes.Modal}
          style={{
            ...style,
            transform: show ? "translateY(0)" : "translateY(-100vh",
            opacity: show ? "1" : "0",
          }}
        >
          {childComp}
        </div>
      </Fragment>
    );
  }
}

export default Modal;
